import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AdminActions {
  DomainEntityType: string,
  orgUnitActionContext: [
    {
      action: string,
      workflowRole: {
        roleIdentifier: string,
        commonName: string,
        roleType: string
      },
      domainEntityType: string,
      userAdminDomainAction: {
        actionType: string,
        actionTypeDisplay: string,
        actionDisplayLabel: string
      }
    }
  ]
}
interface AdminActionsState {
  adminActions: AdminActions[]
  isLoading: boolean
  error: null
}

const initialState: AdminActionsState = {
  adminActions: [],
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'admin-create-actions',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Purpose Types
    getAllAdminCreateActions(state, action: PayloadAction<AdminActions[]>) {
      state.isLoading = false
      state.adminActions = action.payload
      state.error = null
    },
    clearAllAdminCreateActions(state) {
      state.isLoading = false
      state.adminActions = []
      state.error = null
    }
  }
})

// Reducer
export const { getAllAdminCreateActions, hasError, startLoading, clearAllAdminCreateActions } = slice.actions
export default slice.reducer
